import { css } from '@emotion/css';

export const maxW1440 = css`
  max-width: 144rem;
`;

export const px72 = css`
  padding-inline-start: 7.2rem;
  padding-inline-end: 7.2rem;
`;
